import { Statuses, TStatus } from "utils/InterfaceAndTypeGeneral";
import FormatDatesValueObject from "../3_ValuesObjects/FormatDatesValueObject";

export interface ISummaryParams {
  title: string;
  candidateId: string;
  admissionExamId: string;
  availableFrom: FormatDatesValueObject;
  status: TStatus;
  instructions: string;
  duration: number;
  numberOfQuestions: number;
  quizId: string;
}

export default class SummaryEntity {
  private readonly _title: string;
  private readonly _candidateId: string;
  private readonly _admissionExamId: string;
  private readonly _availableFrom: FormatDatesValueObject;
  private readonly _status: TStatus;
  private readonly _instructions: string;
  private readonly _duration: number;
  private readonly _numberOfQuestions: number;
  private readonly _quizId: string;

  constructor(params: ISummaryParams) {
    this._title = params.title;
    this._candidateId = params.candidateId;
    this._admissionExamId = params.admissionExamId;
    this._availableFrom = params.availableFrom;
    this._status = params.status;
    this._instructions = params.instructions;
    this._duration = params.duration;
    this._numberOfQuestions = params.numberOfQuestions;
    this._quizId = params.quizId;
  }

  private getNameStatus() {
    switch (this._status) {
      case Statuses.NOT_DELIVERED:
        return "Por rendir";
      case Statuses.IN_PROGRESS:
        return "En progreso";
      case Statuses.FINISHED:
        return "Finalizado";
      default:
        return "No iniciado";
    }
  }

  private convertSecondsToMinutes(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minutos`;
  }

  private isInProgress(status: string) {
    return status === Statuses.IN_PROGRESS;
  }

  private isScheduled(status: string) {
    return status === Statuses.SCHEDULED;
  }

  private isNotDelivered(status: string) {
    return status === Statuses.NOT_DELIVERED;
  }

  private isDelivered(status: string) {
    return status === Statuses.FINISHED;
  }

  private isOutOfDate(status: string) {
    return status === Statuses.OUT_OF_DATE;
  }

  public toJSON() {
    return {
      title: this._title,
      candidateId: this._candidateId,
      admissionExamId: this._admissionExamId,
      availableFrom: this._availableFrom.value(),
      status: this._status,
      statusName: this.getNameStatus(),
      instructions: this._instructions,
      duration: this._duration,
      durationName: this.convertSecondsToMinutes(this._duration),
      numberOfQuestions: this._numberOfQuestions,
      isInProgress: this.isInProgress(this._status),
      isNotDelivered: this.isNotDelivered(this._status),
      isScheduled: this.isScheduled(this._status),
      isDelivered: this.isDelivered(this._status),
      isOutOfDate: this.isOutOfDate(this._status),
      quizId: this._quizId,
    };
  }
}
